<ct-type-attribute-grid
  [gridConfiguration]="gridConfiguration"
  [gridSettings]="gridSetting"
  [type]="'test'"
  [data]="data"
  (onGridConfigurationChangue)="onGridConfigurationChange($event)"
></ct-type-attribute-grid>
